import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Auth state hasn't been determined yet — don't decide anything.
  if (isLoading) {
    return null; // or a <SplashScreen /> / loading spinner
  }

  if (!isAuthenticated) {
    const returnTo = encodeURIComponent(
      `${location.pathname}${location.search || ''}`
    );
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return children;
};

export default ProtectedRoute;